import { render, staticRenderFns } from "./AzGroupsList.vue?vue&type=template&id=58b3951e"
import script from "./AzGroupsList.vue?vue&type=script&lang=js"
export * from "./AzGroupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports